import { formatDistance, parseISO, format } from "date-fns";
import { differenceInDays } from "date-fns/esm";

// // We want to make this function work for both Date objects and strings (which come from Supabase)
export const subtractDates = (dateStr1, dateStr2) =>
  differenceInDays(parseISO(String(dateStr1)), parseISO(String(dateStr2)));

export const formatDistanceFromNow = (dateStr) => {
  try {
    const parsedDate = Date.parse(dateStr);
    const dist = formatDistance(parsedDate, new Date(), {
      addSuffix: true,
      includeSeconds: true,
    });
    return dist;
  } catch (err) {
    return null;
  }
};

// Supabase needs an ISO date string. However, that string will be different on every render because the MS or SEC have changed, which isn't good. So we use this trick to remove any time
export const getToday = function (options = {}) {
  const today = new Date();

  // This is necessary to compare with created_at from Supabase, because it it not at 0.0.0.0, so we need to set the date to be END of the day when we compare it with earlier dates
  if (options?.end)
    // Set to the last second of the day
    today.setUTCHours(23, 59, 59, 999);
  else today.setUTCHours(0, 0, 0, 0);
  return today.toISOString();
};

export const formatCurrency = (value) =>
  isNaN(value)
    ? ""
    : new Intl.NumberFormat("en", {
        style: "currency",
        currency: "USD",
      }).format(value);

export function isDateInFuture(dateString) {
  const parsedDate = new Date(Date.parse(dateString));
  if (isNaN(parsedDate.getTime())) {
    return null;
  }
  const currentDate = new Date();
  if (parsedDate > currentDate) return true;
  else return false;
}

export function formatDate(dateString) {
  try {
    if (!dateString) return;
    var parsedDate = Date.parse(dateString);
    if (isNaN(parsedDate)) return;
    const date = new Date(parsedDate);
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    }).format(date);
    return formattedDate;
  } catch (err) {
    return null;
  }
}
export function formatDate2(dateString) {
  if (dateString && dateString !== "nan") {
    try {
      const formattedDate = format(new Date(dateString), "yyyy-MM-dd");
      return formattedDate;
    } catch (err) {
      return null;
    }
  }
  return null;
}
export function truncateStringToMaxWords(inputString, maxWords) {
  // Split the input string into an array of words
  const words = inputString?.split(/\s+/);

  // Check if the number of words exceeds the maximum
  if (words?.length > maxWords) {
    // Slice the array to get the first `maxWords` words and join them back into a string
    const truncatedString = words.slice(0, maxWords).join(" ");

    // Add ellipsis (...) to indicate truncation if desired
    return truncatedString + "...";
  }

  // If the number of words is within the limit, return the original string
  return inputString;
}

export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) return;
  // Remove any non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, "");

  // Check the length and format accordingly
  if (cleaned.length === 10) {
    return `(${cleaned.substring(0, 3)}) ${cleaned.substring(
      3,
      6
    )}-${cleaned.substring(6)}`;
  } else {
    return cleaned; // Return the original if it doesn't match the format
  }
}

export function toPascalCase(str) {
  return str?.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function toTitleCase(str) {
  if (!str) return str;

  const firstWord = str.split(" ")[0];
  const restWords = str.slice(firstWord.length);

  return (
    firstWord.charAt(0).toUpperCase() +
    firstWord.slice(1) +
    restWords.toLowerCase()
  );
}

export function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    return new Promise((resolve) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(async () => {
        const result = await func(...args);
        resolve(result); // Resolve the promise with the result
      }, delay);
    });
  };
}

export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
};
